import React, { useEffect, useState } from "react";
import { DialogBox } from "@softura/fluentuipackage";
import close from "../../assets/images/Close_SuccessPopup.svg";
import "./PopupDilalogBox.scss";
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import OutlineButton from "../Button/OutlineButton/OutlineButton";
import { EventHandler, InputField } from "..";
import { CONSTANTS } from "client/utils/constants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

interface IProps {
  hideDialog?: any;
  onDismiss?: any;
  Popupcontent?: any;
  popupOutlinebtnOnclick?: any;
  popupPrimarybtnOnclick?: any;
  orderDetails?: any;
  requestOption?: any;
  selectedKey?: any;
  popupAdditionalBtnOnCLick?: any;
  className?:any;
  commentBoxId?: string;
}

const PopupDialogbox = ({
  hideDialog,
  onDismiss,
  Popupcontent,
  popupOutlinebtnOnclick,
  popupPrimarybtnOnclick,
  popupAdditionalBtnOnCLick,
  orderDetails,
  requestOption,
  selectedKey,
  className,
  commentBoxId
}: IProps) => {
  const [popupComments, setpopupComments] = useState(Popupcontent.comment);
  const [popupCommentError, setPopupCommentError] = useState(false);

  const {
    requisitionApprovalData,
    selectedOptionsSubmit
  }: any = useSelector((state: any) => ({
    requisitionApprovalData: state.ApprovalReducer.requisitionApprovalData,
    selectedOptionsSubmit: state.OrderApprovalReducer.selectedOptionsSubmit
  }))

  const navigate = useNavigate();

  const popupCancelbtnOnclick = () => {
    setpopupComments("");
    popupOutlinebtnOnclick(Popupcontent.outlineBtnnavigateTo)
  }

  const popupAdditionalBtnOnclick = () => {
    setpopupComments("");
    popupAdditionalBtnOnCLick(Popupcontent.additionalBtnnavigateTo)
  }

  const popupSavebtnOnclick = () => {
    setpopupComments("");
    popupPrimarybtnOnclick(
      Popupcontent.primaryBtnnavigateTo,
      popupComments,
      Popupcontent.actionby,
      Popupcontent.value
    )
  }
  interface IApproveSummary {
    type: string,
    rejectedCount: number,
    returnedCount: number,
    approvedCount: number
  }
  const [popupMessageing, setPopupMessaging] = useState<IApproveSummary[]>([])
  const popupcommentonchange = (_e: any, text: string) => {
    if (text.length > 500) {
      setPopupCommentError(true);
    } else {
      setPopupCommentError(false);
    }
    setpopupComments(text);
    if (text?.length <= 0) {
      Popupcontent.isCommentBoxRequire = true;
    } else {
      Popupcontent.isCommentBoxRequire = false;
    }
  };
  useEffect(() => {
    setpopupComments(Popupcontent.comment);
  }, [Popupcontent]);

  useEffect(() => {
    if (popupComments?.length > 500) {
      setPopupCommentError(true);
    } else {
      setPopupCommentError(false);
    }
  }, [popupComments]);

  useEffect(() => {
    let approvalSummaryList: IApproveSummary[] = [];

    let approveCountTemp = 0;
    let rejectCountTemp = 0;
    let returnCountTemp = 0;

    {
      selectedOptionsSubmit?.length ?
        selectedOptionsSubmit?.map((item: any, index: any) => {
          if (item?.approverActionId == "1") {
            approveCountTemp = approveCountTemp + 1
          } else if (item?.approverActionId == "2") {
            rejectCountTemp = rejectCountTemp + 1
          } else {
            returnCountTemp = returnCountTemp + 1
          }
        }) :
        orderDetails?.requests?.length &&
        orderDetails?.requests.map((item: any, index: number) => {
              (
                (requestOption[index]?.request == "Approve" ||  Popupcontent.actionby == "approveConfirmationBtn") ? (
                  approveCountTemp = approveCountTemp + 1
                ) : (requestOption[index]?.request == "Reject" || Popupcontent.actionby == "RejectSubmitBtn") ? (
                  rejectCountTemp = rejectCountTemp + 1
                ) : (
                  returnCountTemp = returnCountTemp + 1
                )
              )
        })
      const requisitionsummary: IApproveSummary = {
        type: orderDetails?.isBulkOrder ? CONSTANTS.BULK_ORDER : CONSTANTS.REQUISITION,
        rejectedCount: rejectCountTemp,
        returnedCount: returnCountTemp,
        approvedCount: approveCountTemp
      }
      if (rejectCountTemp > 0 || returnCountTemp > 0 || approveCountTemp > 0) {
        approvalSummaryList.push(requisitionsummary);
      }
      setPopupMessaging(approvalSummaryList)
    }
  }, [Popupcontent, requestOption])

  const onOrderIdClick = (e: any, orderId: any) => {
    e.preventDefault();
    navigate('/ordermanagement/requisitionorderdetail/' + orderId + '/home');
  }

  const dialogContentProps = {
    title: (
      <>
        <div className={`popup-content ${className}`}>
                  <div className="close-btn-Popup">
                      <EventHandler onEvent={() =>
                          Popupcontent?.isAdditionalConfirmationBtn ? popupAdditionalBtnOnclick() : onDismiss()
                      } data-attribute="PopupDilalogBox_Default_EventHandler">
                      <img src={close} alt="close" />
                      </EventHandler>            
                  </div>
          <div className="popup-titleImg">
            <img src={Popupcontent.titleImg} alt="close" />
          </div>
          <div
            className={Popupcontent.isTitleWarning ? "warning" : "popup-title"}
          >
            <p>{Popupcontent.title}</p>
          </div>
        </div>
      </>
    ),
    closeButtonAriaLabel: "Close",
    subText: (
      <div className= {
        Popupcontent?.isAdditionalConfirmationBtn
          ? "popup-subcontent Additional-btn"
          : "popup-subcontent"
      }>
        <div
          className={
            Popupcontent.isTitleWarning
              ? "popup-subtext-warning"
              : "popup-subtext"
          }
        >
          {Popupcontent.subtextcontent}
        </div>
        <div className="popup-commentarea">
          <div
            className={
              Popupcontent.isCommentboxVisible
                ? "commentBox mb-3"
                : "commentBox-Notshown"
            }
          >
            <InputField
              id={commentBoxId}
              onFocus={(e: any) =>
                e.currentTarget.setSelectionRange(
                  e.currentTarget.value.length,
                  e.currentTarget.value.length
                )
              }
              multiline={true}
              row="3"
              value={popupComments}
              resizable={false}
              placeholder="Comment"
              name="text"
              onChange={popupcommentonchange}
             data-attribute="PopupDilalogBox_text_Input" />
          </div>
          {popupCommentError ? (
            <span className="asset-validation-msg">
              {"Please enter comments below 500 characters"}
            </span>
          ) : null}
          <div>
            {popupMessageing != undefined &&
              popupMessageing?.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={
                      Popupcontent.isCompletedReportVisible
                        ? "completed-report mb-3"
                        : "completed-report-nonactive"
                    }
                  >
                    <div className="left-section">
                      {(
                        <p>
                          <b>{item.type}</b>
                        </p>
                      )}
                    </div>
                    <div className="right-section">
                      {
                        item.approvedCount != 0 ? (
                          <span>
                            <span className="fa fa-check-circle-o completed-btn order-status">
                              {" "}
                            </span>{" "}
                            Approved{" "} - {item.approvedCount} {(requisitionApprovalData?.approvedOrderNo && selectedOptionsSubmit?.length ) ? <span className="order-group"> <span className="Order-Bold"> Order# : </span><a href="/" onClick={(e: any) => onOrderIdClick(e, requisitionApprovalData?.approvedOrderNo)}>{requisitionApprovalData?.approvedOrderNo}</a> </span> : null}
                          </span>
                        ) : null}
                      {
                        item.rejectedCount != 0 ? (
                          <span>
                            <span className="fa fa-times-circle-o rejected-btn order-status">
                              {" "}
                            </span>{" "}
                            Rejected - {item.rejectedCount} {(requisitionApprovalData?.rejectedOrderNo && selectedOptionsSubmit?.length ) ? <span className="order-group"> <span className="Order-Bold"> Order# : </span><a href="/" onClick={(e: any) => onOrderIdClick(e, requisitionApprovalData?.rejectedOrderNo)}>{requisitionApprovalData?.rejectedOrderNo}</a> </span> : null}
                          </span>
                        ) : null}
                      {
                        item.returnedCount != 0 ? (
                          <span>
                            <span className="fa fa-exclamation-circle returned-btn order-status">
                              {" "}
                            </span>{" "}
                            Request More Info{" "}- {item.returnedCount} {(requisitionApprovalData?.returnOrderNo && selectedOptionsSubmit?.length ) ? <span className="order-group"> <span className="Order-Bold"> Order# : </span><a href="/" onClick={(e: any) => onOrderIdClick(e, requisitionApprovalData?.returnOrderNo)}>{requisitionApprovalData?.returnOrderNo}</a></span> : null}
                          </span>
                        ) : null}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="popupbtn">
          <OutlineButton
            text={Popupcontent.outlineBtnText}
            onClick={() => popupCancelbtnOnclick()
            }
           data-attribute="PopupDilalogBox_Default_Button" />
          <PrimaryButton
            text={Popupcontent.primaryBtnText}
            className={
              Popupcontent.isSingleConfirmationBtn
                ? "singleBtnConfirmation"
                : ""
            }
            disabled={
              (Popupcontent.isCommentBoxRequire && (popupComments?.length <= 0) && Popupcontent?.actionby != "Approve") ||
                popupCommentError ||
                Popupcontent.isPrimaryBtnDisabled 
                ? true
                : false
            }
            onClick={() =>
              popupSavebtnOnclick()
              // popupPrimarybtnOnclick(
              //   Popupcontent.primaryBtnnavigateTo,
              //   popupComments,
              //   Popupcontent.actionby,
              //   Popupcontent.value
              // )
            }
           data-attribute="PopupDilalogBox_Default_Button_2" />
          <OutlineButton
          className={
            Popupcontent?.isAdditionalConfirmationBtn
              ? ""
              : "singleBtnConfirmation"
          }
            text={Popupcontent.additionalBtnText}
            onClick={() => popupAdditionalBtnOnclick()
            }
           data-attribute="PopupDilalogBox_Default_Button_3" />
        </div>
      </div>
    ),
    styles: {
      subText: {
        color: "black",
      },
    },
  };

  return (
    <>
      {
        !hideDialog ? <DialogBox
          hideDialog={hideDialog}
          dialogContentProps={dialogContentProps}
          selectedKey={selectedKey}
         data-attribute="PopupDilalogBox_Default_DialogBox"></DialogBox> : ''
      }
    </>
  );
};

export default PopupDialogbox;
